"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Vue } from "vue-property-decorator";
let PasswordInput = class extends Vue {
  constructor() {
    super(...arguments);
    this.inputType = "password";
    this.eyeIcon = "eye-slash";
  }
  elInput(value) {
    this.$emit("input", value);
  }
  clearPassword() {
    this.$emit("input", null);
  }
  changeStatus() {
    if (this.inputType === "password") {
      this.inputType = "text";
    } else {
      this.inputType = "password";
    }
  }
};
__decorateClass([
  PropSync("value", {
    type: String,
    default: function() {
      return "";
    }
  })
], PasswordInput.prototype, "_password_value", 2);
PasswordInput = __decorateClass([
  Component
], PasswordInput);
export {
  PasswordInput as default
};
